/** Farm-animal catalog and graze-wander constants. */

export const GRAZE_RADIUS_TILES = 10;
export const WALK_FRAME_MS = 125;
export const GRAZE_FRAME_MS = 220;
export const STEP_MIN_TILES = 1;
export const STEP_MAX_TILES = 2.5;
export const GRAZE_MIN_S = 1.2;
export const GRAZE_MAX_S = 3.5;
/** Update facing only when |dx| / distance exceeds this (nearly-vertical steps keep facing). */
export const FACE_HORIZONTAL_RATIO = 0.15;

export const SPECIES = {
  cow: {
    id: 'cow',
    name: 'Cow',
    sizeClass: 'L',
    frameW: 32,
    frameH: 32,
    speed: 0.7,
    walkFrames: 4,
    grazeFrames: 4,
    colorBudget: 12,
  },
  sheep: {
    id: 'sheep',
    name: 'Sheep',
    sizeClass: 'L',
    frameW: 32,
    frameH: 32,
    speed: 0.85,
    walkFrames: 4,
    grazeFrames: 4,
    colorBudget: 12,
  },
  chicken: {
    id: 'chicken',
    name: 'Chicken',
    sizeClass: 'S',
    frameW: 16,
    frameH: 16,
    speed: 1.4,
    walkFrames: 4,
    grazeFrames: 4,
    colorBudget: 9,
  },
  horse: {
    id: 'horse',
    name: 'Horse',
    sizeClass: 'L',
    frameW: 32,
    frameH: 32,
    speed: 1.2,
    walkFrames: 4,
    grazeFrames: 4,
    colorBudget: 12,
  },
  pig: {
    id: 'pig',
    name: 'Pig',
    sizeClass: 'L',
    frameW: 32,
    frameH: 32,
    speed: 0.9,
    walkFrames: 4,
    grazeFrames: 4,
    colorBudget: 12,
  },
};

export const SPECIES_ORDER = ['cow', 'sheep', 'chicken', 'horse', 'pig'];

export function isSpecies(id) {
  return Object.hasOwn(SPECIES, id);
}
